// Module
var code = "<div>\n    <div class=\"bike-grid__bike-title\">{{ bike.make }} {{ bike.model }}<span\n            ng-show=\"bike.year\">, {{ bike.year }}</span></span>\n    </div>\n    <div class=\"bike-grid__bike-sn\">\n        SN:\n        <span data-ng-bind-html=\"bike.serialNumber|notSpecified\"></span>\n    </div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'components/bike/list/base/bl-item-details.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;